module.exports = __webpack_public_path__ + "images/help/icon-twr28-648fbb866d0b7825b53b7ae21cc211f7.png";